import { createContext, useContext, useState, useCallback, useMemo } from "react";
import Loader from "../components/Loader/Loader";

const LoaderContext = createContext(null);

export const LoaderProvider = ({ children }) => {
  const [count, setCount] = useState(0);
  const [text, setText] = useState("");

  const startLoader = useCallback((message = "") => {
    setCount((c) => c + 1);
    setText(message);
  }, []);

  const stopLoader = useCallback(() => {
    setCount((c) => {
      const next = Math.max(0, c - 1);
      if (next === 0) setText("");
      return next;
    });
  }, []);

  const value = useMemo(() => ({ startLoader, stopLoader }), [startLoader, stopLoader]);

  return (
    <LoaderContext.Provider value={value}>
      {count > 0 && <Loader text={text} />}
      {children}
    </LoaderContext.Provider>
  );
};

export const useLoader = () => {
  const ctx = useContext(LoaderContext);
  if (!ctx) throw new Error("useLoader must be used inside LoaderProvider");
  return ctx;
};
